import {deviceTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = deviceTypes;

const path = `iot/device`;

const base = new BaseAction(types);

export const getDeviceDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedDeviceDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getDeviceData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedDeviceData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addDeviceData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editDeviceData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteDeviceData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreDeviceData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteDeviceData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
